import React, { memo } from 'react';
import cn from 'classnames';

import { ISwitcherOption, ISwitcherProps } from './interfaces';

import styles from './Switcher.module.scss';

const Switcher = ({
	options,
	value,
	handleChange,
}: ISwitcherProps) => {
	const onSwitch = (option: ISwitcherOption) => () => handleChange(option);

	return (
		<div className={styles.switcherContainer}>
			{options.map(option => {
				return (
					<div
						key={option.id}
						className={cn(styles.switcherOption, {
							[styles.selectedSwitcherOption]: value?.value === option.value,
						})}
						onClick={onSwitch(option)}
					>
						{option.label}
					</div>
				);
			})}
		</div>
	);
};

export default memo(Switcher);
